if (!customElements.get('nfc-review-carousel')) {
  customElements.define(
    'nfc-review-carousel',
    class NfcReviewCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.track = this.querySelector('[data-review-track]');
        this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
        this.dotsContainer = this.querySelector('[data-review-dots]');
        this.previousButton = this.querySelector('[data-review-previous]');
        this.nextButton = this.querySelector('[data-review-next]');
        this.activeIndex = 0;

        if (!this.track || this.cards.length === 0) return;

        this.onPrevious = () => this.goTo(this.activeIndex - 1);
        this.onNext = () => this.goTo(this.activeIndex + 1);
        this.onScroll = this.handleScroll.bind(this);

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.renderDots();
        this.updateDots();
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.initialized = false;
      }

      renderDots() {
        if (!this.dotsContainer || this.cards.length < 2) return;
        this.dotsContainer.replaceChildren();

        this.cards.forEach((card, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'nfc-reviews__dot';
          dot.setAttribute('aria-label', `Ver reseña ${index + 1}`);
          dot.addEventListener('click', () => this.goTo(index));
          this.dotsContainer.appendChild(dot);
        });
      }

      goTo(index) {
        const nextIndex = (index + this.cards.length) % this.cards.length;
        this.cards[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        this.activeIndex = nextIndex;
        this.updateDots();
      }

      handleScroll() {
        window.cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = window.requestAnimationFrame(() => {
          const trackLeft = this.track.getBoundingClientRect().left;
          let nearestIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;

          this.cards.forEach((card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          if (nearestIndex !== this.activeIndex) {
            this.activeIndex = nearestIndex;
            this.updateDots();
          }
        });
      }

      updateDots() {
        this.dotsContainer?.querySelectorAll('.nfc-reviews__dot').forEach((dot, index) => {
          dot.setAttribute('aria-current', index === this.activeIndex ? 'true' : 'false');
        });
      }
    }
  );
}
